import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from '../ui/Button';
import { Workspace } from '../../types/workspace';
interface WorkspaceCreationModalProps {
  onClose: () => void;
  onCreateWorkspace: (workspace: Partial<Workspace>) => void;
}
export function WorkspaceCreationModal({
  onClose,
  onCreateWorkspace
}: WorkspaceCreationModalProps) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [purpose, setPurpose] = useState('analysis');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onCreateWorkspace({
      name,
      description,
      purpose
    });
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-112">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md" data-id="element-113">
        <div className="flex justify-between items-center p-4 border-b border-gray-200" data-id="element-114">
          <h2 className="text-xl font-semibold" data-id="element-115">Create New Workspace</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-116">
            <X size={20} data-id="element-117" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-4" data-id="element-118">
          <div className="mb-4" data-id="element-119">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-120">
              Workspace Name
            </label>
            <input type="text" value={name} onChange={e => setName(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="e.g., NPS Improvement Project" required data-id="element-121" />
          </div>
          <div className="mb-4" data-id="element-122">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-123">
              Description
            </label>
            <textarea value={description} onChange={e => setDescription(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Describe the purpose of this workspace" rows={3} data-id="element-124" />
          </div>
          <div className="mb-4" data-id="element-125">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-126">
              Workspace Purpose
            </label>
            <select value={purpose} onChange={e => setPurpose(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-127">
              <option value="analysis" data-id="element-128">Insight Analysis</option>
              <option value="product" data-id="element-129">Product Development</option>
              <option value="marketing" data-id="element-130">Marketing Campaign</option>
              <option value="customer" data-id="element-131">Customer Experience</option>
              <option value="other" data-id="element-132">Other</option>
            </select>
          </div>
          <div className="flex justify-end space-x-3 mt-6" data-id="element-133">
            <Button variant="outline" onClick={onClose} data-id="element-134">
              Cancel
            </Button>
            <Button type="submit" disabled={!name.trim()} data-id="element-135">
              Create Workspace
            </Button>
          </div>
        </form>
      </div>
    </div>;
}